import { buildUrl, handleResponse } from "./auth";

const jsonHeaders = { "Content-Type": "application/json" };

export const getAdminPartners = () =>
  fetch(buildUrl("/api/admin/partners"), {
    credentials: "include",
  }).then(handleResponse);

export const getAdminPartnerDetail = (partnerId) =>
  fetch(buildUrl(`/api/admin/partners/${partnerId}`), {
    credentials: "include",
  }).then(handleResponse);

export const createAdminPartner = (payload) =>
  fetch(buildUrl("/api/admin/partners"), {
    method: "POST",
    headers: jsonHeaders,
    body: JSON.stringify(payload ?? {}),
    credentials: "include",
  }).then(handleResponse);

export const updateAdminPartner = (partnerId, payload) =>
  fetch(buildUrl(`/api/admin/partners/${partnerId}`), {
    method: "PUT",
    headers: jsonHeaders,
    body: JSON.stringify(payload ?? {}),
    credentials: "include",
  }).then(handleResponse);

export const deleteAdminPartner = (partnerId) =>
  fetch(buildUrl(`/api/admin/partners/${partnerId}`), {
    method: "DELETE",
    credentials: "include",
  }).then(handleResponse);

export const revealAdminPartnerPin = (partnerId) =>
  fetch(buildUrl(`/api/admin/partners/${partnerId}/pin`), {
    credentials: "include",
  }).then(handleResponse);

export const resetAdminPartnerPin = (partnerId) =>
  fetch(buildUrl(`/api/admin/partners/${partnerId}/pin/reset`), {
    method: "POST",
    credentials: "include",
  }).then(handleResponse);

const adminPartnersApi = {
  getAdminPartnerDetail,
  getAdminPartners,
  createAdminPartner,
  deleteAdminPartner,
  updateAdminPartner,
  revealAdminPartnerPin,
  resetAdminPartnerPin,
};

export default adminPartnersApi;
